<template>
<div>
  <Topbar></Topbar>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row my-3 ml-auto">
          <div class="col-10">
            <h1>
              <span>Users</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <b-table
        class="table table-hover" data-sortable="true"
        show-empty
        stacked="md"
        id="projects-table"
        :items="users"
        :per-page="perPage"
        :fields="fields"
        :current-page="currentPage"
      >

        <template slot="username" slot-scope="row">
          <router-link :to="'/user/' + row.item.id">{{ row.value }}</router-link>
        </template>
        <template slot="role" slot-scope="row">
          {{ row.value }}
        </template>

      </b-table>
    </div>
    <div class="row my-5 fixed-bottom justify-content-center">
      <b-pagination
        v-model="currentPage"
        :total-rows="users.length"
        :per-page="perPage"
        aria-controls="users-table"
      ></b-pagination>
    </div>
  </div>

</div>
</template>

<script>
import Topbar from '../components/Topbar'
export default {
  name: 'Users',
  components: {
    Topbar
  },
  computed: {
    users () {
      return this.$store.getters.users
    }
  },
  data () {
    return {
      fields: [
        { key: 'username', label: 'Username' },
        { key: 'role', label: 'Role' }
      ],
      currentPage: 1,
      perPage: 5
    }
  }
}
</script>

<style scoped>

</style>
